
export const fetchFromAirtable = async (table, id = null, filter = null, fieldName = null) => {
  let url = `https://api.airtable.com/v0/appD48APNaGA4GN0B/${table}`;
  if (id) url += `/${id}`;
  if (filter && fieldName) {
    url += `?filterByFormula=FIND("${filter}", {${fieldName}})`;
  }

  try {
    const response = await fetch(url, {
      headers: {
        Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
        'content-type': 'application/x-www-form-urlencoded',
        "Accept": "application/json, text/plain, /"
    },
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return await response.json();
  } catch (e) {
    console.error(`🔴 Erreur fetch ${table}`, e);
    return null;
  }
};

export const fetchRecordsFields = async (table, filterId, fieldName) => {
  const res = await fetchFromAirtable(table, null, filterId, fieldName);
  return res?.records?.map(r => r.fields) || [];
};
